import { v4 as uuidv4 } from 'uuid';
import getCookie from './get-cookie';
import setCookie from './set-cookie';

const getDeviceId = (key = 'gi_flt_session', expiryTime = 525600) => {
  //set default expiry time to an year
  let uid = getCookie(key);
  if (!uid && key !== 'gi_flt_session') {
    const now = new Date();
    const minutes = expiryTime;
    now.setTime(now.getTime() + minutes * 60 * 1000);
    const expiry = now.toUTCString();
    uid = uuidv4();
    setCookie(key, uid, expiry, '/', window.location.host.replace('www.', ''), '');
  }
  return uid;
};

export default getDeviceId;
